import { Box } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";

import Text from "./text/Text";
import { getStartedTxt, sats, swap } from "./messages";
import Button from "./button/Button";
import SwapCommon from "./swap/SwapCommon";
import SwapCurrencyDrawer from "./swap/SwapCurrencyDrawer";

function NewToSpeedWallet({
  isFromBrowser,
  currency,
  currencyColor,
  currencyIcon,
  walletBGImage,
  balances,
  balanceAmount,
  isShowSwapButton,
  supportedSwaps,
}) {
  const { showBtcAmount } = useSelector((state) => state.common);
  const [
    isOpenSelectCurrencyForSwapModal,
    setIsOpenSelectCurrencyForSwapModal,
  ] = useState(false);
  const [selectedAssetForSwapBalance, setSelectedAssetForSwapBalance] =
    useState(0);
  const [selectedAssetForSwap, setSelectedAssetForSwap] = useState(null);
  const [isOpenSwapModal, setIsOpenSwapModal] = useState(false);

  const handleOpenSwapModal = () => {
    setIsOpenSelectCurrencyForSwapModal(true);
  };

  const swapModalProps = {
    isFromBrowser,
    isOpenSwapModal,
    setIsOpenSwapModal,
    selectedAssetForSwap,
    currency,
    currencyIcon,
    showBtcAmount,
    currentAssetBalance: balanceAmount,
    selectedAssetForSwapBalance,
    textSize: isFromBrowser ? 16 : 14,
    supportedSwaps,
  };

  return (
    <>
      <Box
        className={`new-speed-wallet-wrapper ${currencyColor}`}
        padding={"0 15px"}
        position="relative"
        margin="0 0 10px"
        minHeight="265px"
      >
        <img
          src={currencyIcon}
          alt="welcome-to-speed"
          height="50px"
          width="50px"
        />
        <Text
          className="default-text"
          size={20}
          font="bold"
          sx={{ marginTop: "19px", width: "313px", textAlign: "center" }}
        >
          {getStartedTxt(currency === sats ? "BTC" : currency)}
        </Text>
        {isShowSwapButton && (
          <Box marginTop={"30px"} width={"100%"}>
            <Button
              type="submit"
              fullWidth
              label={swap}
              sx={{
                backgroundColor: "white",
                zIndex: 1,
              }}
              icon="swapIcon"
              iconPosition="start"
              className={`button-icon-${currency}`}
              onClick={handleOpenSwapModal}
            />
          </Box>
        )}
        {walletBGImage}
      </Box>
      {isOpenSelectCurrencyForSwapModal && (
        <SwapCurrencyDrawer
          isOpenModal={isOpenSelectCurrencyForSwapModal}
          setIsOpenModal={setIsOpenSelectCurrencyForSwapModal}
          isFromBrowser={isFromBrowser}
          balances={balances}
          setSelectedAssetForSwap={setSelectedAssetForSwap}
          setIsOpenSwapModal={setIsOpenSwapModal}
          setSelectedAssetForSwapBalance={setSelectedAssetForSwapBalance}
          supportedSwaps={supportedSwaps}
        />
      )}
      {isOpenSwapModal && <SwapCommon {...swapModalProps} />}
    </>
  );
}

export default NewToSpeedWallet;
